/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';

import { JobRfqDto } from './job-rfq.dto';

export const JobRfqMapper = entity<JobRfqDto>({
  inspectedDate: date(DateFormat.Date),
});
